import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { Tooltip } from "../Tooltip";

interface ConfirmAllButtonProps {
  count: number;
  confirming: boolean;
  onConfirmAll: () => void;
}

// D1 amendment 2.8 (5), round 28 Marketing L3 and round 29 Risk M2; in the product's
// voice since words follow-ups 5 (LF-176).
const CONFIRM_ALL_TOOLTIP =
  "Accept the suggestions for the entries listed. Any you undid, or any we " +
  "returned to you, you confirm one at a time.";

/** "Confirm N suggestions": the shown targets' count on the button. */
export function ConfirmAllButton({
  count,
  confirming,
  onConfirmAll,
}: ConfirmAllButtonProps): ReactNode {
  return (
    <div className="confirm-all-container">
      <Tooltip text={CONFIRM_ALL_TOOLTIP}>
        <motion.button
          type="button"
          className="confirm-all-btn"
          onClick={onConfirmAll}
          disabled={confirming}
          whileHover={{ scale: 1.02, y: -2 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
        >
          {confirming ? "Confirming..." : `Confirm ${count} suggestions`}
        </motion.button>
      </Tooltip>
    </div>
  );
}
